import React from 'react';
import { useImpersonation } from '../../../contexts/impersonation-context/ImpersonationContext';

/**
 * ImpersonationFrame component
 *
 * Previously showed an orange border around the app and a bottom banner.
 * Now replaced with a simpler UI - orange highlight on the SwitchAccount icon in the sidebar.
 *
 * The modal accessible via the SwitchAccount icon provides options to:
 * - Select a different company
 * - Return to developer panel
 */
export const ImpersonationFrame: React.FC = () => {
  const { isImpersonating } = useImpersonation();

  // Visual indicator now handled by sidebar icon highlight
  // No additional UI elements needed
  return null;
};
